import styled from "styled-components"
import { FaSpotify, FaSoundcloud, FaBandcamp } from "react-icons/fa";
import { BsAppleMusic } from "react-icons/bs";

const getPlatformKey = (url) => {
    if (url.includes("soundcloud")) return "Soundcloud";
    if (url.includes("bandcamp")) return "Bandcamp";
    if (url.includes("spotify")) return "Spotify";
    if (url.includes("apple")) return "Apple";
    return "Other";
};

const platformMap = {
    Spotify: <FaSpotify />,
    Soundcloud: <FaSoundcloud />,
    Bandcamp: <FaBandcamp />,
    Apple: <BsAppleMusic />
}

const platformColors = {
    Spotify: "#1ed760",
    Soundcloud: "#F37422",
    Apple: "#FF0436",
    Bandcamp: "#629aa9"
}

const PlatformButton = ({platform, link}) => {
    const SelfButton = styled.a `
    transition: 0.15s all linear;
    &:hover {
    color: ${platformColors[platform]};
    cursor: pointer;
    }
    `

    return (
        <SelfButton href={link} target="_blank" rel="noreferrer">
            {platformMap[platform]}
        </SelfButton>
    )
}

export default function StreamingGrid({links}) {
    const StreamingGrid = styled.div `
    display: flex;
    column-gap: 10px;
    row-gap: 10px;
    margin-top: 10px;
    flex-direction: row;
    font-size: 20pt;
    `
    return (
        <StreamingGrid>
            {links.map(l => <PlatformButton platform={getPlatformKey(l)} link={l} />)}
        </StreamingGrid>
    )
}